import { apiSujetosGetEmpresasGET } from '../api/Pioneer/endpoints/subjects/subjects.api';
import { CompanyStoreModel } from '../redux';
import { mapCompaniesToStore } from '../redux/store.mapper';

export const fetchCompanies = async (): Promise<CompanyStoreModel[]> => {
  return await apiSujetosGetEmpresasGET().then(res => mapCompaniesToStore(res));
};
